import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {
  errorHandler,
  nameRender,
  successHandler,
} from "../../../../../utils/functions";
import queryGenerator from "../../../../../utils/queryGenarator";

const initialState = {
  list: null,
  user: null,
  error: null,
  loading: false,
  total: 0,
};

export const addStaff = createAsyncThunk("user/addStaff", async (values) => {
  try {
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `user/register`,
      data: {
        ...values,
      },
    });

    return successHandler(data, "Staff Added successfully");
  } catch (error) {
    return errorHandler(error, true);
  }
});

export const updateStaff = createAsyncThunk(
  "user/updateStaff",
  async ({ id, values }) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/${id}`,
        data: values,
      });

      return successHandler(data, "Staff updated successfully");
    } catch (error) {
      return errorHandler(error, true);
    }
  }
);
export const deleteStaff = createAsyncThunk(
  "user/deleteStaff",
  async ({ id, status }) => {
    try {
      const { data } = await axios({
        method: "patch",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/${id}`,
        data: {
          status: status ? status : "false",
        },
      });

      return successHandler(
        data,
        `Staff ${status === "true" ? "is activate" : "deleted"} successfully`
      );
    } catch (error) {
      return errorHandler(error, true);
    }
  }
);

export const loadSingleStaff = createAsyncThunk(
  "user/loadSingleStaff",
  async (id) => {
    try {
      const { data } = await axios.get(`user/${id}`);
      return {
        data,
        message: "success",
      };
    } catch (error) {
      errorHandler(error, false);
    }
  }
);

export const loadAllStaff = createAsyncThunk(
  "user/loadAllStaff",
  async (arg) => {
    try {
      const finalArg = { ...arg };
      if (finalArg.query === "all") {
        finalArg.status = "true";
        finalArg.count = 10000;
      }
      const query = queryGenerator(finalArg, false);
      const { data } = await axios.get(`user?${query}`);
      return successHandler(data);
    } catch (error) {
      return errorHandler(error);
    }
  }
);

export const addUser = createAsyncThunk("user/addUser", async (values) => {
  try {
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `user/login`,
      data: values,
    });

    localStorage.setItem("access-token", data.data.token);
    localStorage.setItem("role", data.data.role);
    localStorage.setItem("roleId", data.data.roleId);
    localStorage.setItem("user", nameRender(data.data));
    localStorage.setItem("id", data.data.id);
    localStorage.setItem("isLogged", true);

    return successHandler(data.data, "Login Successfully Done");
  } catch (error) {
    return errorHandler(error, true);
  }
});
export const agentLogin = createAsyncThunk("user/agentLogin", async (values) => {
  try {
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `agent-auth/login`,
      data: values,
    });

    localStorage.setItem("access-token", data.data.token);
    localStorage.setItem("role", data.data.role);
    localStorage.setItem("roleId", data.data.roleId);
    localStorage.setItem("user", nameRender(data.data));
    localStorage.setItem("email", data.data.email);
    localStorage.setItem("id", data.data.id);
    localStorage.setItem("isLogged", true);

    return successHandler(data.data, "Login Successfully Done");
  } catch (error) {
    return errorHandler(error, true);
  }
});
export const agentChangePassword = createAsyncThunk("user/agentChangePassword", async (values) => {
  try {
    const token = localStorage.getItem("access-token");
    const { data } = await axios({
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
      url: `agent-auth/change-password`,
      data: values,
    });

    return successHandler(data, "Password updated successfully");
  } catch (error) {
    return errorHandler(error, true);
  }
});
export const logOut = createAsyncThunk("user/logOut", async () => {
  try {
    const id = Number(localStorage.getItem("id"));
    const roleId = localStorage.getItem("roleId");

    if (roleId !== "9") {
      await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/logout`,
        data: { id },
      });
    }

    localStorage.clear();
    if (roleId === "9") {
      window.location.href = "/agents/login";
    } else {
      window.location.href = "/admin/auth/login";
    }
    return successHandler({ message: "success" }, "LogOut Successfully Done");
  } catch (error) {
    localStorage.clear();
    window.location.href = "/admin/auth/login";
    return errorHandler(error, true);
  }
});

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUser: (state) => {
      state.user = null;
    },
    clearUserList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    // 1) ====== builders for loadAllStaff ======

    builder.addCase(loadAllStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadAllStaff.fulfilled, (state, action) => {
      state.loading = false;
      const responseData = action.payload?.data;
      if (Array.isArray(responseData)) {
        state.list = responseData;
        state.total = responseData.length;
      } else if (responseData) {
        state.list = responseData.getAllUser || [];
        state.total = responseData.totalUser || 0;
      } else {
        state.list = [];
        state.total = 0;
      }
    });

    builder.addCase(loadAllStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2) ====== builders for addStaff ======

    builder.addCase(addStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addStaff.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 3) ====== builders for addUser ======

    builder.addCase(addUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addUser.fulfilled, (state, action) => {
      state.loading = false;

      if (!Array.isArray(state.user)) {
        state.user = [];
      }
      const user = [...state.user];
      user.push(action.payload?.data);
      state.user = user;
    });

    builder.addCase(addUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for loadSingleStaff ======

    builder.addCase(loadSingleStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadSingleStaff.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload.data;
    });

    builder.addCase(loadSingleStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 5) ====== builders for deleteStaff ======

    builder.addCase(deleteStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(deleteStaff.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 6) ====== builders for agentLogin ======

    builder.addCase(agentLogin.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(agentLogin.fulfilled, (state, action) => {
      state.loading = false;
      if (!Array.isArray(state.user)) {
        state.user = [];
      }
      const user = [...state.user];
      user.push(action.payload?.data);
      state.user = user;
    });

    builder.addCase(agentLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

export default userSlice.reducer;
export const { clearUser, clearUserList } = userSlice.actions;
